import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, ViewEncapsulation, ViewChild } from '@angular/core';
import {DemoService} from '../../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';

// import {CurrentsDataSourceComponent} from '../../../../views/appviews/currents-data-source/currents-data-source.component';
import { Job } from '../../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';
import { Subscription } from 'rxjs';

import { FileUploaderService } from './../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { SubjectCommunication } from '../../../../shared/models/subjectCommunication.model';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';


@Component({
  selector: 'app-subject-documents',
  templateUrl: './subject-documents.component.html',
  styleUrls: ['./subject-documents.component.css']
})
export class SubjectDocumentsComponent implements OnInit {


  
  public ajaxSettings: object;
  public path: string;
  public hostUrl = 'https://ej2-aspcore-service.azurewebsites.net/';
 


  currentUserVAR: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
  tableData: any;
  job_id: string;
  subject_id: number;
  subjects: Object;
  tableSubjectData: any;
  subject_number: any;
  file_number: any;
  modalRef: BsModalRef;
  sessionUsername: any;
  all_router_details: string;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public gfunc: GlobalFunctionsService
  ) {

    // this.toastr.setRootViewContainerRef(vcr);

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


    this.subject_id = +this.route.snapshot.paramMap.get('subject_id');

   }
  

  ngOnInit() {

  
    this.getJobSubject(this.subject_id);

console.log('subject_id: ', this.subject_id);
console.log('subject_number: ', this.subject_number);
console.log('subject_file_number: ', this.file_number);

    this.ajaxSettings = {
      url: this.hostUrl + 'api/FileManager/FileOperations',
      getImageUrl: this.hostUrl + 'api/FileManager/GetImage',
      uploadUrl: this.hostUrl + 'api/FileManager/Upload',
      downloadUrl: this.hostUrl + 'api/FileManager/Download'
  };
  // Specify the required current path
  this.path = '/';

    



// this.refreshList(); // loads the file list (diretory)
// this.job_id = ''; // loads the enire job directory

  }


  // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};



  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
       data => { this.subjects = data;
        const res = data[0];

        this.job_id = res.job_id;
        this.subject_number = res.subject_number;
        this.file_number = res.file_number;
        this.refreshList(); // loads the file list (diretory)
        // this.displaySubjectDocuments(this.subject_id, this.subject_number);

     //   this.getSubjectNotes(res.subject_id);
 // load subject history
// this.getSubjectProgress(res.job_id, res.file_number);

// get job type in relation to subject
// this.getJobType(res.job_type_id);
// this.getJobTypeLocation(res.job_type_location_id);
// this.getJobTypeCourt(res.job_type_court_id);
// this.getJobTypeDocument(res.job_type_document_type_id);
// this.getJobTypeAffidavit(res.job_type_affidavit_type_id);

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  subjectView2(subject_id) {
      
    this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']));
  
  // works but does not refresh the page only if set up as a listner.
  // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
 }

 jobView(job_id) {
  this.router.navigate(['/admin/jobs/view/' + job_id + '']);
}


subjectCommunication(subject_id) {
  this.router.navigate(['/admin/jobs/subject/communication/' + subject_id + '']);
}

subjectDocuments(subject_id) {
  this.router.navigate(['/admin/jobs/subject/documents/' + subject_id + '']);
}


private refreshList(): void {
  // notice the update here for traces
this.fileUploader.getJobFiles(this.job_id).subscribe(res => this.displayTableData(res));

}

displaySubjectDocuments(subject_id, subject_number){
  this.fileUploader.getJobSubjectFiles(this.subject_id, this.subject_number).subscribe(res => this.displaySubjectFiles(res));
}

private displayTableData(data: any): void {
  // this.tableData = data.json();
  this.tableData = data;
  }


  private displaySubjectFiles(data: any): void {
    // this.tableSubjectData = data.json();
    this.tableSubjectData = data;
    }



}
